
import { defineComponent } from 'vue';

import SocialMediaIconBox from '../../../components/Frontend/SocialMediaIconBox.vue';
import Footer from '../../../components/Frontend/Footer.vue';
import { mdiChevronUp, mdiFormatQuoteClose } from '@mdi/js';


export default defineComponent({
  meta: {
    de: {
      title: 'Management | Styria Media Group',
      keywords: ['management', 'vorstand', 'markus mair', 'kurt kribitz', 'bernhard kiener', 'aufsichtsrat', 'eigentümer', 'styria'],
      description: 'Markus Mair, Kurt Kribitz, Bernhard Kiener: die Vorstände der Styria Media Group.',
      image: require('@/assets/img/og/ueber-uns.png'),

    },
    en: {
      title: 'Management | Styria Media Group',
      keywords: ['management', 'vorstand', 'markus mair', 'kurt kribitz', 'bernhard kiener', 'aufsichtsrat', 'eigentümer', 'styria'],
      description: 'Markus Mair, Kurt Kribitz, Bernhard Kiener: the executive board of the Styria Media Group.',
      image: require('@/assets/img/og/ueber-uns.png'),
    },
  },
  components: {
    SocialMediaIconBox,
    Footer
  },
  setup() {
    return {
      mdiChevronUp,
      mdiFormatQuoteClose,
    };
  },
});
